import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'

/**
 * Eine Reiterleiste — dieselbe in jedem Fenster und auf jeder Detailseite.
 *
 * Das Firmenprofil, das Unterstützer:innenprofil und der Unterstützungsbedarf
 * hatten je eine eigene, leicht abweichende Leiste. Solange es nur drei waren,
 * ging das; mit dem Reiter „Kommentare" an jedem Datensatz wären es acht
 * geworden — acht Stellen, an denen dieselbe Bedienung leicht anders aussieht.
 *
 * Die Beschriftung kommt als i18n-Schlüssel (`label`), nicht als fertiger Text:
 * So bleibt die Leiste zweisprachig, ohne dass jede Ansicht daran denken muss.
 */
export default function TabBar({ tabs, active, onChange, className, tabsRef }) {
	const { t } = useTranslation()

	return (
		<div className={clsx(styles.tabs, className)} ref={tabsRef} role="tablist">
			{tabs.map(tab => (
				<button
					key={tab.key}
					type="button"
					role="tab"
					aria-selected={active === tab.key}
					className={clsx(styles.tab, active === tab.key && styles.tabActive)}
					onClick={() => onChange(tab.key)}
				>
					{/* Ampel am Reiter: Wo eine Ansicht keinen Stand kennt, bleibt sie weg. */}
					{tab.done !== undefined && tab.done !== null && (
						<span
							className={clsx(styles.tabDot, tab.done ? styles.tabDotDone : styles.tabDotOpen)}
							title={tab.done ? t('Complete') : t('Incomplete')}
						/>
					)}
					{t(tab.label)}
					{typeof tab.count === 'number' && tab.count > 0 && (
						<span className={styles.tabCount}>{tab.count}</span>
					)}
				</button>
			))}
		</div>
	)
}

TabBar.propTypes = {
	tabs: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			done: PropTypes.bool,
			count: PropTypes.number
		})
	).isRequired,
	active: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	className: PropTypes.string,
	tabsRef: PropTypes.object
}
